import { useState } from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Card,
  CardHeader,
  CardBody,
  useColorModeValue,
} from "@chakra-ui/react";
import BreadCrumbMaker from "../../../components/BreadCrumbMaker";

const InvoiceReceipts = () => {
  const bgColor = useColorModeValue("white", "gray.800");

  const breadcrumbItems = [
    { title: "Finance", link: "/finance/customer" },
    { title: "Invoice & Receipts", link: "/finance/invoice-receipts" },
  ];

  return (
    <Container maxW="container.xl" py={6}>
      <BreadCrumbMaker items={breadcrumbItems} />
      <Heading size="lg" mb={6}>
        Generate Invoice and Receipts
      </Heading>

      <VStack spacing={4} align="stretch">
        <Card bg={bgColor}>
          <CardHeader>
            <Heading size="md">Invoices & Receipts</Heading>
          </CardHeader>
          <CardBody>
            <Text color="gray.500">
              Invoice and receipt generation will be available here. This section
              is under development.
            </Text>
          </CardBody>
        </Card>
      </VStack>
    </Container>
  );
};

export default InvoiceReceipts;
